import { memo } from 'react';

type TabProps = {
  onScrollToDay: (id: any) => void;
  days: any;
  active?: any;
};

const Tabs: React.FC<TabProps> = ({ onScrollToDay, days, active }) => {
  const handleClick = (tab: number) => {
    onScrollToDay(tab);
  };

  return (
    <div className="scrollbar-hide mr-[-16px] flex flex-row space-x-2.5 overflow-x-auto whitespace-nowrap bg-white leading-4 md:space-x-3">
      {days.map((tab: any, index: number) => {
        return (
          <div
            key={index}
            className={`cursor-pointer snap-start rounded-full p-2 font-inter text-sm  md:px-4 md:py-2 ${
              active === tab
                ? 'bg-rhubarb-lite text-rhubarb-dark'
                : 'text-grey-dark'
            }`}
          >
            <p onClick={() => handleClick(tab)}>
              Day
              <span className="pl-1.5 font-interMedium text-base">
                0{index + 1}
              </span>
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default memo(Tabs);
